

// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import sound from "../../../../images/alaram.mp3";

// const MobileDeliveryorders = () => {
//     const [isHovered, setIsHovered] = useState(false);
//     const [expandedOrder, setExpandedOrder] = useState(null);
//     const [orders, setOrders] = useState([]);
//     const [checkedItems, setCheckedItems] = useState({});
//     const [vendorId, setVendorId] = useState(null);
//     const scrollContainerRef = useRef(null);
//     const notificationSound = new Audio(sound);

//     useEffect(() => {
//         const storedVendorId = localStorage.getItem("vendorId");
//         setVendorId(storedVendorId);
//     }, []);

//     const handleCheckboxChange = (listId) => {
//         setCheckedItems((prev) => ({
//             ...prev,
//             [listId]: !prev[listId],
//         }));
//         //console.log("Selected List ID:", listId);
//     };


//     const handleCancelSingleOrder = async (listId) => {
//         try {
//             const token = localStorage.getItem("authToken"); // ✅ Adjust key name if needed

//             if (!token) {
//                 alert("Authorization token not found!");
//                 return;
//             }

//             const response = await fetch(
//                 `https://backend.maamaas.com/food/orderscancellationlist/edit/${listId}`,
//                 {
//                     method: "PUT",
//                     headers: {
//                         "Content-Type": "application/json",
//                         "Authorization": `Bearer ${token}`, // 👈 Add token here
//                     },
//                     body: JSON.stringify({
//                         status: "Cancelled",
//                     }),
//                 }
//             );

//             if (!response.ok) {
//                 console.error(`Failed to cancel order ${listId}`);
//                 alert(`Failed to cancel order ${listId}`);
//             } else {
//                 //console.log(`Order ${listId} cancelled successfully.`);
//                 alert(`Order ${listId} has been cancelled.`);
//                 // Optional: Uncheck after cancellation
//                 setCheckedItems((prev) => {
//                     const updated = { ...prev };
//                     delete updated[listId];
//                     return updated;
//                 });
//             }
//         } catch (error) {
//             console.error("Error cancelling order:", error);
//         }
//     };


//     const handleOrderClick = (order) => {
//         const id = order.orderId || order.cartId; // normalize ID
//         //console.log("Clicked order:", order); // ✅ debug

//         if (expandedOrder && expandedOrder.id === id) {
//             //console.log("Collapsing order:", id);
//             setExpandedOrder(null); // collapse
//         } else {
//             //console.log("Expanding order:", id);
//             setExpandedOrder({ ...order, id }); // expand
//         }
//     };






//     useEffect(() => {
//         const storedVendorId = localStorage.getItem("vendorId");
//         setVendorId(storedVendorId);
//     }, []);


//     const [acceptedItems, setAcceptedItems] = useState({});

//     const [selectedItems, setSelectedItems] = useState({});

//     // Toggle checkbox
//     const handleCheckboxChangea = (itemId) => {
//         setSelectedItems((prev) => ({
//             ...prev,
//             [itemId]: !prev[itemId],
//         }));
//     };
//     const handleAcceptOrderrss = async (e, itemId) => {
//         e.stopPropagation();

//         const status = "CANCELLED";
//         const note = "sds"; // optional note 
//         const url = `https://backend.maamaas.com/food/api/cart/cartitem/status/${itemId}?status=${status}&note=${encodeURIComponent(note)}`;

//         try {
//             const response = await fetch(url, {
//                 method: "PUT", // or POST depending on your API
//                 headers: {
//                     "Content-Type": "application/json",
//                 },
//             });

//             if (!response.ok) {
//                 throw new Error(`Error: ${response.status}`);
//             }

//             const data = await response.json();
//             //console.log("✅ Status updated:", data);

//             // Optional: update local state so UI reflects change
//             // e.g., remove item from list or update its status
//         } catch (error) {
//             console.error("❌ Failed to update status:", error);
//         }
//     };

//     const handleAcceptOrderrsss = async (e, cartId, selectedItemIds = []) => {
//         e.stopPropagation();

//         const status = "PROCESSING";
//         const note = "Selected items accepted";
//         const token = localStorage.getItem("authToken"); // ✅ Get token from localStorage

//         if (!token) {
//             alert("Authentication token is missing.");
//             return;
//         }

//         if (selectedItemIds.length === 0) {
//             alert("Please select at least one item to process.");
//             return;
//         }

//         const itemIdsParam = selectedItemIds.join("&itemIds=");
//         const url = `https://backend.maamaas.com/food/api/cart/cart/status/${cartId}?itemIds=${itemIdsParam}&status=${status}&note=${encodeURIComponent(note)}`;

//         try {
//             const response = await fetch(url, {
//                 method: "PUT",
//                 headers: {
//                     "Content-Type": "application/json",
//                     Authorization: `Bearer ${token}`, // ✅ Added token to headers
//                 },
//             });

//             if (!response.ok) throw new Error(`Error: ${response.status}`);

//             const data = await response.json();
//             //console.log("✅ Selected items accepted:", data);

//             // Optionally update UI
//             // Example: refresh orders or clear selections
//         } catch (error) {
//             console.error("❌ Failed to accept items:", error);
//             alert("Failed to process selected items. Please try again.");
//         }
//     };
//     // Accept selected items



//     const handleAcceptOrderr = async (e, orderId) => {
//         e.stopPropagation();

//         const token = localStorage.getItem("authToken"); // ✅ Retrieve token
//         if (!token) {
//             alert("Authentication token is missing.");
//             return;
//         }

//         try {
//             const response = await axios.put(
//                 `https://backend.maamaas.com/food/api/orders/edit-orders/${orderId}/WAITING_FOR_PICKUP`,
//                 {
//                     status: "WAITING_FOR_PICKUP", // send in body
//                 },
//                 {
//                     headers: {
//                         Authorization: `Bearer ${token}`, // ✅ Add token to headers
//                     },
//                 }
//             );

//             //console.log("Status updated:", response.data);

//             // Update local UI
//             setOrders((prev) => prev.filter((order) => order.orderId !== orderId));
//         } catch (error) {
//             console.error("Failed to update order status:", error.response?.data || error.message);
//         }
//     };



//     useEffect(() => {
//         if (!vendorId) return; // skip if vendorId is null

//         const fetchOrders = async () => {
//             const token = localStorage.getItem("authToken");
//             if (!token) {
//                 console.warn("Auth token missing. Skipping order fetch.");
//                 return;
//             }

//             try {
//                 // 1️⃣ Fetch all vendor orders
//                 const vendorRes = await axios.get(
//                     `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
//                     { headers: { Authorization: `Bearer ${token}` } }
//                 );

//                 const allVendorOrders = vendorRes.data || [];
//                 //console.log("✅ All Vendor Orders:", allVendorOrders);

//                 // 2️⃣ Filter PROCESSING orders
//                 const processingOrders = allVendorOrders.filter(
//                     (order) => order.status === "ORDER_IS_READY"
//                 );
//                 //console.log("🔹 Processing Orders:", processingOrders);

//                 // 3️⃣ Filter TABLE_DINE_IN orders with BEING_PREPARED items
//                 const dineInPreparedOrders = allVendorOrders.filter(
//                     (order) =>
//                         order.orderType === "TABLE_DINE_IN" &&
//                         Array.isArray(order.cartItems) &&
//                         order.cartItems.some((item) => item.orderStatus === "ORDER_IS_READY")
//                 );
//                 //console.log("🔹 TABLE_DINE_IN BEING_PREPARED Orders:", dineInPreparedOrders);

//                 // 4️⃣ Fetch direct TABLE_DINE_IN BEING_PREPARED orders
//                 const directDineInRes = await axios.get(
//                     `https://backend.maamaas.com/food/api/cart/get/ordertype=TABLE_DINE_IN/${vendorId}/ORDER_IS_READY`,
//                     { headers: { Authorization: `Bearer ${token}` } }
//                 );

//                 const directDineInOrders = directDineInRes.data || [];
//                 //console.log("🔹 Direct TABLE_DINE_IN Orders:", directDineInOrders);

//                 // 5️⃣ Merge all orders
//                 const mergedOrders = [
//                     ...processingOrders,
//                     ...dineInPreparedOrders,
//                     ...directDineInOrders
//                 ];
//                 //console.log("🔹 Merged Orders:", mergedOrders);

//                 // 6️⃣ Deduplicate by cartId or orderId
//                 const uniqueOrders = mergedOrders.filter(
//                     (order, index, self) =>
//                         index ===
//                         self.findIndex(
//                             (o) =>
//                                 (o.cartId && o.cartId === order.cartId) ||
//                                 (o.orderId && o.orderId === order.orderId)
//                         )
//                 );
//                 //console.log("✅ Unique Orders after deduplication:", uniqueOrders);

//                 setOrders(uniqueOrders);
//             } catch (error) {
//                 console.error("❌ Failed to fetch orders:", error.response?.data || error.message);
//             }
//         };

//         fetchOrders(); // initial fetch
//         const intervalId = setInterval(fetchOrders, 1000); // repeat every second

//         return () => clearInterval(intervalId); // cleanup
//     }, [vendorId]);




//     // Horizontal Auto-scroll
//     useEffect(() => {
//         const scrollContainer = scrollContainerRef.current;
//         if (!scrollContainer) return;

//         let interval = setInterval(() => {
//             if (!isHovered) {
//                 scrollContainer.scrollLeft += 1;
//                 if (scrollContainer.scrollLeft >= scrollContainer.scrollWidth / 2) {
//                     scrollContainer.scrollLeft = 0;
//                 }
//             }
//         }, 20);

//         return () => clearInterval(interval);
//     }, [isHovered]);

//     const getOrderColor = (orderType) => {
//         const normalized = (orderType || "").trim().toLowerCase();
//         switch (normalized) {
//             case "dine_in":
//                 return "#1E90FF";
//             case "takeaway":
//                 return "#FF6347";
//             case "delivery":
//                 return "#20B2AA";
//             case "table_dine_in":
//                 return "#2051b2ff";
//             default:
//                 return "#ccc";
//         }
//     };



//     const handleAcceptOrder = async (e, orderId) => {
//         e.stopPropagation();
//         const token = localStorage.getItem("authToken");
//         if (!token) return;

//         try {
//             await axios.put(
//                 `https://backend.maamaas.com/food/orders/editstatus/${orderId}`,
//                 { orderStatus: "CONFIRMED" },
//                 { headers: { Authorization: `Bearer ${token}` } }
//             );
//             setOrders((prev) => prev.filter((order) => order.orderId !== orderId));
//         } catch (error) {
//             console.error("Accept error:", error.response?.data || error.message);
//         }
//     };

//     const handleDeclineOrder = async (e, orderId) => {
//         e.stopPropagation();

//         const token = localStorage.getItem("authToken");
//         if (!token) {
//             alert("Authentication token is missing.");
//             return;
//         }

//         try {
//             const response = await axios.put(
//                 `https://backend.maamaas.com/food/api/orders/cancal/total/order/${orderId}`,
//                 {}, // ✅ Empty body (if your API doesn’t need one)
//                 {
//                     headers: {
//                         Authorization: `Bearer ${token}`, // ✅ Correct placement
//                         "Content-Type": "application/json",
//                     },
//                 }
//             );

//             //console.log("✅ Status updated:", response.data);

//             // ✅ Update UI after successful cancellation
//             setOrders((prev) => prev.filter((order) => order.orderId !== orderId));

//         } catch (error) {
//             console.error(
//                 "❌ Failed to update order status:",
//                 error.response?.data || error.message
//             );

//             if (error.response?.status === 403) {
//                 alert("Access denied. Your session may have expired — please log in again.");
//             }
//         }
//     };


//     return (
//         <div>
//             {/* Internal CSS */}
//             <style>
//                 {`
//                 @media (min-width: 768px) {
//                 .order-card{
//                 display:none !important;
//                 }
               
//                 }

             
//         @media (max-width: 768px) {
        
//           .mobile-orders-wrapper {
//             width: 100%;
//             left: 0;
//             right: 0;
        
//             top: 0px;
//             height: auto;
      
//             padding: 10px;
//             border-radius: 0;
//           }

//          /* Inside your <style> tag */
// .mobile-scroll-container {
//   display: flex;
//   flex-direction: row;
//   overflow-x: auto;
//   gap: 12px;
//   padding-bottom: 10px;
//   scroll-behavior: smooth;
//   margin-top: 60px;
//   background:#fff;
//   -ms-overflow-style: none; /* IE */
//   scrollbar-width: none; /* Firefox */
// }

// .order-card {
//   flex-shrink: 0;
//   width: 280px;          /* ✅ Fixed width for consistency */
//   max-width: 90vw;       /* ✅ Prevents overflow on small screens */
//     /* ✅ Keeps consistent height */
//   border-radius: 10px;
//   box-shadow: 0px 3px 6px rgba(0,0,0,0.15);
//   padding: 12px;
//   transition: all 0.3s ease-in-out;
// }

//         }

//         .hide-scrollbar {
//           -ms-overflow-style: none;
//           scrollbar-width: none;
//         }

//         .hide-scrollbar::-webkit-scrollbar {
//           display: none;
//         }
//         `}
//             </style>

//             <div
//                 className="mobile-orders-wrapper"
//                 style={{
//                     position: "fixed",

//                     right: "16px",
//                     borderRadius: "8px",
//                     padding: "10px",
//                     marginTop: "40px",
//                 }}
//             >
//                 <div
//                     className="hide-scrollbar"
//                     style={{
//                         maxHeight: "600px",
//                         overflowY: "auto",
//                         paddingRight: "5px",
//                         // marginTop: "30px",
//                     }}
//                     onMouseEnter={() => setIsHovered(true)}
//                     onMouseLeave={() => setIsHovered(false)}
//                 >
//                     <div className="mobile-scroll-container" ref={scrollContainerRef}>
//                         {orders.map((order, index) => {
//                             const uniqueId = order.orderId || order.cartId;
//                             const itemsList = order.items || order.order || order.cartItems || [];

//                             const isExpanded =
//                                 expandedOrder &&
//                                 (expandedOrder.orderId === uniqueId || expandedOrder.cartId === uniqueId);

//                             return (
//                                 <div
//                                     key={`${uniqueId}-${index}`}
//                                     onClick={() => handleOrderClick(order)}
//                                     className="order-card scroll-data-responsive"
//                                     style={{
//                                         cursor: "pointer",
//                                         background: getOrderColor(order.orderType),
//                                         position: "relative",
//                                         height: isExpanded ? "auto" : "auto",
//                                     }}
//                                 >

//                                     <div style={{ width: "100%" }}>
//                                         {/* Header */}
//                                         <div
//                                             style={{
//                                                 display: "flex",
//                                                 justifyContent: "space-between",
//                                                 alignItems: "center",
//                                                 color: "#fff",
//                                                 fontWeight: "bold",
//                                             }}
//                                         >
//                                             <div style={{ display: "flex" }}>
//                                                 <div
//                                                     style={{

//                                                         color: "rgba(255, 255, 255, 0.9)",
//                                                         marginRight: "10px",
//                                                         fontSize: "18px",
//                                                         transition: "transform 0.3s ease",
//                                                         transform: expandedOrder?.orderId === order.orderId ? "rotate(180deg)" : "rotate(0deg)",
//                                                         // Add this line:
//                                                     }}
//                                                 >
//                                                     ▼
//                                                 </div>

//                                                 Order ID: #{uniqueId}
//                                             </div>
//                                             <h5 style={{ marginTop: "0px" }}>{order.orderType === "DINE_IN" ? "DINEIN" : order.orderType || "N/A"}</h5>
//                                         </div>




//                                         {isExpanded && (
//                                             <div style={{ marginTop: "-10px" }}>
//                                                 {/* Headers for items list */}
//                                                 <div style={{
//                                                     display: 'flex',
//                                                     justifyContent: 'space-between',
//                                                     alignItems: 'center',
//                                                     padding: '8px 10px',
//                                                     borderRadius: '4px',
//                                                     marginBottom: '0px',
//                                                     fontWeight: 'bold',
//                                                     fontSize: '16px',
//                                                     color: '#fff'
//                                                 }}>
//                                                     <div style={{ flex: 0, textAlign: 'left' }}>Items</div>
//                                                     <div style={{ flex: 1, textAlign: 'center' }}>Quantity</div>
//                                                 </div>

//                                                 {order.orderType === "TABLE_DINE_IN" && (
//                                                     <ul
//                                                         style={{ listStyle: "none", padding: 0, marginLeft: "10px", fontWeight: "bold" }}
//                                                         onClick={(e) => e.stopPropagation()}
//                                                     >
//                                                         {itemsList.map((item, idx) => (
//                                                             <li
//                                                                 key={idx}
//                                                                 style={{
//                                                                     display: "flex",
//                                                                     justifyContent: "space-between",
//                                                                     alignItems: "center",
//                                                                     color: "#000",
//                                                                     fontSize: "14px",
//                                                                     marginBottom: "3px",
//                                                                     padding: "0px 10px 8px 10px",
//                                                                     borderRadius: '4px'
//                                                                 }}
//                                                             >
//                                                                 <div style={{ display: "flex", alignItems: "center", gap: "10px", flex: 2 }}>
//                                                                     <input
//                                                                         type="checkbox"
//                                                                         checked={!!selectedItems[item.itemId]}
//                                                                         onChange={(e) => {
//                                                                             e.stopPropagation();
//                                                                             handleCheckboxChangea(item.itemId);
//                                                                         }}
//                                                                     />
//                                                                     <span style={{ fontWeight: "600" }}>
//                                                                         {item.dishName || "Unnamed Dish"}
//                                                                     </span>
//                                                                 </div>
//                                                                 <div style={{ flex: 1, textAlign: 'start' }}>
//                                                                     × {item.updateQuantity ?? 0}
//                                                                 </div>
//                                                             </li>
//                                                         ))}
//                                                     </ul>
//                                                 )}

//                                                 {/* Non-TABLE_DINE_IN items */}
//                                                 <ul style={{ listStyle: "none", padding: 0, marginLeft: "10px", fontWeight: "bold" }}>
//                                                     {itemsList
//                                                         .filter((item) => item.status === "Okay")
//                                                         .map((item, idx) => (
//                                                             <li
//                                                                 key={idx}
//                                                                 style={{
//                                                                     color: "#000",
//                                                                     fontSize: "14px",
//                                                                     marginBottom: "3px",
//                                                                     display: "flex",
//                                                                     justifyContent: "space-between",
//                                                                     alignItems: "center",
//                                                                     padding: "0px 10px8px 10px",
//                                                                     borderRadius: '4px'
//                                                                 }}
//                                                                 onClick={(e) => e.stopPropagation()}
//                                                             >
//                                                                 <div style={{ display: "flex", alignItems: "center", gap: "8px", flex: 2 }}>
//                                                                     <input
//                                                                         type="checkbox"
//                                                                         checked={!!checkedItems[item.listId]}
//                                                                         onChange={() => handleCheckboxChange(item.listId)}
//                                                                     />
//                                                                     <span>{item.dishName}</span>
//                                                                 </div>
//                                                                 <div style={{ flex: 1, textAlign: 'start' }}>
//                                                                     × {item.quantity}
//                                                                 </div>
//                                                                 <div style={{ flex: 1, textAlign: 'right' }}>
//                                                                     <button
//                                                                         onClick={() => handleCancelSingleOrder(item.listId)}
//                                                                         style={{
//                                                                             padding: "4px 8px",
//                                                                             backgroundColor: "rgb(220, 53, 69)",
//                                                                             color: "white",
//                                                                             fontSize: "12px",
//                                                                             fontWeight: "bold",
//                                                                             border: "none",
//                                                                             borderRadius: "5px",
//                                                                             cursor: "pointer",
//                                                                         }}
//                                                                     >
//                                                                         Cancel
//                                                                     </button>
//                                                                 </div>
//                                                             </li>
//                                                         ))}
//                                                 </ul>
//                                             </div>
//                                         )}



//                                         {order.orderType === "TABLE_DINE_IN" && (
//                                             <div
//                                                 style={{
//                                                     display: "flex",
//                                                     justifyContent: "space-between",
//                                                     marginTop: "10px",
//                                                 }}
//                                             >
//                                                 <button
//                                                     onClick={(e) => {


//                                                         // Pass selected items to your API
//                                                         handleAcceptOrderrsss(e, order.cartId);
//                                                     }}
//                                                     style={{
//                                                         padding: "8px",
//                                                         backgroundColor: "rgb(177 93 198)",
//                                                         color: "white",
//                                                         fontSize: "14px",
//                                                         fontWeight: "bold",
//                                                         border: "none",
//                                                         borderRadius: "5px",
//                                                         cursor: "pointer",
//                                                     }}
//                                                 >
//                                                     Accept
//                                                 </button>
//                                                 <button
//                                                     onClick={(e) => {
//                                                         e.stopPropagation();
//                                                         handleAcceptOrderrss(e, order.cartId); // ✅ using cartId instead of itemId
//                                                     }}
//                                                     style={{
//                                                         padding: "8px",
//                                                         backgroundColor: "rgb(177 93 198)",
//                                                         color: "white",
//                                                         fontSize: "14px",
//                                                         fontWeight: "bold",
//                                                         border: "none",
//                                                         borderRadius: "5px",
//                                                         cursor: "pointer",
//                                                     }}
//                                                 >
//                                                     Decline
//                                                 </button>
//                                             </div>
//                                         )}




//                                         {/* Buttons for non-TABLE_DINE_IN orders */}
//                                         {order.orderType !== "TABLE_DINE_IN" && (
//                                             <div
//                                                 style={{
//                                                     display: "flex",
//                                                     justifyContent: "space-between",
//                                                     marginTop: "10px",
//                                                 }}
//                                             >
//                                                 <button
//                                                     onClick={(e) => handleAcceptOrderr(e, uniqueId)}
//                                                     style={{
//                                                         padding: "8px",
//                                                         backgroundColor: "rgb(177 93 198)",
//                                                         color: "white",
//                                                         fontSize: "14px",
//                                                         fontWeight: "bold",
//                                                         border: "none",
//                                                         borderRadius: "5px",
//                                                         cursor: "pointer",
//                                                     }}
//                                                 >
//                                                     Accept
//                                                 </button>
//                                                 <button
//                                                     onClick={(e) => handleDeclineOrder(e, uniqueId)}
//                                                     style={{
//                                                         padding: "8px",
//                                                         backgroundColor: "rgb(177 93 198)",
//                                                         color: "white",
//                                                         fontSize: "14px",
//                                                         fontWeight: "bold",
//                                                         border: "none",
//                                                         borderRadius: "5px",
//                                                         cursor: "pointer",
//                                                     }}
//                                                 >
//                                                     Decline
//                                                 </button>
//                                             </div>
//                                         )}
//                                     </div>
//                                 </div>
//                             );
//                         })}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default MobileDeliveryorders;








import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import sound from "../../../../images/alaram.mp3";

const MobileDeliveryorders = () => {
    const [isHovered, setIsHovered] = useState(false);
    const [expandedOrder, setExpandedOrder] = useState(null);
    const [orders, setOrders] = useState([]);
    const [checkedItems, setCheckedItems] = useState({});
    const [vendorId, setVendorId] = useState(null);
    const scrollContainerRef = useRef(null);
    const notificationSound = new Audio(sound);
      const prevOrdersRef = useRef([]);
    

    useEffect(() => {
        const storedVendorId = localStorage.getItem("vendorId");
        setVendorId(storedVendorId);
    }, []);

    const handleCheckboxChange = (listId) => {
        setCheckedItems((prev) => ({
            ...prev,
            [listId]: !prev[listId],
        }));
    };


    const handleCancelSingleOrder = async (listId) => {
        try {
            const token = localStorage.getItem("authToken"); // ✅ Adjust key name if needed

            if (!token) {
                alert("Authorization token not found!");
                return;
            }

            const response = await fetch(
                `https://backend.maamaas.com/food/orderscancellationlist/edit/${listId}`,
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`, // 👈 Add token here
                    },
                    body: JSON.stringify({
                        status: "Cancelled",
                    }),
                }
            );

            if (!response.ok) {
                console.error(`Failed to cancel order ${listId}`);
                alert(`Failed to cancel order ${listId}`);
            } else {
                alert(`Order ${listId} has been cancelled.`);
                // Optional: Uncheck after cancellation
                setCheckedItems((prev) => {
                    const updated = { ...prev };
                    delete updated[listId];
                    return updated;
                });
            }
        } catch (error) {
            console.error("Error cancelling order:", error);
        }
    };


    const handleOrderClick = (order) => {
        const id = order.orderId || order.cartId; // normalize ID

        if (expandedOrder && expandedOrder.id === id) {
            setExpandedOrder(null); // collapse
        } else {
            setExpandedOrder({ ...order, id }); // expand
        }
    };






    useEffect(() => {
        const storedVendorId = localStorage.getItem("vendorId");
        setVendorId(storedVendorId);
    }, []);


    const [acceptedItems, setAcceptedItems] = useState({});

    const [selectedItems, setSelectedItems] = useState({});

    // Toggle checkbox
    const handleCheckboxChangea = (itemId) => {
        setSelectedItems((prev) => ({
            ...prev,
            [itemId]: !prev[itemId],
        }));
    };
    const handleAcceptOrderrss = async (e, itemId) => {
        e.stopPropagation();

        const status = "CANCELLED";
        const note = "sds"; // optional note 
        const url = `https://backend.maamaas.com/food/api/cart/cartitem/status/${itemId}?status=${status}&note=${encodeURIComponent(note)}`;

        try {
            const response = await fetch(url, {
                method: "PUT", // or POST depending on your API
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) {
                throw new Error(`Error: ${response.status}`);
            }

            const data = await response.json();

            // Optional: update local state so UI reflects change
            // e.g., remove item from list or update its status
        } catch (error) {
            console.error("❌ Failed to update status:", error);
        }
    };

    const handleAcceptOrderrsss = async (e, cartId, selectedItemIds = []) => {
        e.stopPropagation();

        const status = "PROCESSING";
        const note = "Selected items accepted";
        const token = localStorage.getItem("authToken"); // ✅ Get token from localStorage

        if (!token) {
            alert("Authentication token is missing.");
            return;
        }

        if (selectedItemIds.length === 0) {
            alert("Please select at least one item to process.");
            return;
        }

        const itemIdsParam = selectedItemIds.join("&itemIds=");
        const url = `https://backend.maamaas.com/food/api/cart/cart/status/${cartId}?itemIds=${itemIdsParam}&status=${status}&note=${encodeURIComponent(note)}`;

        try {
            const response = await fetch(url, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`, // ✅ Added token to headers
                },
            });

            if (!response.ok) throw new Error(`Error: ${response.status}`);

            const data = await response.json();

            // Optionally update UI
            // Example: refresh orders or clear selections
        } catch (error) {
            console.error("❌ Failed to accept items:", error);
            alert("Failed to process selected items. Please try again.");
        }
    };
    // Accept selected items



    const handleAcceptOrderr = async (e, orderId) => {
        e.stopPropagation();

        const token = localStorage.getItem("authToken"); // ✅ Retrieve token
        if (!token) {
            alert("Authentication token is missing.");
            return;
        }

        try {
            const response = await axios.put(
                `https://backend.maamaas.com/food/api/orders/edit-orders/${orderId}/WAITING_FOR_PICKUP`,
                {
                    status: "WAITING_FOR_PICKUP", // send in body
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`, // ✅ Add token to headers
                    },
                }
            );


            // Update local UI
            setOrders((prev) => prev.filter((order) => order.orderId !== orderId));
        } catch (error) {
            console.error("Failed to update order status:", error.response?.data || error.message);
        }
    };



    useEffect(() => {
        const fetchOrders = async () => {
            if (!vendorId) return;

            const token = localStorage.getItem("authToken");
            if (!token) {
                console.warn("No auth token found. Skipping fetch.");
                return;
            }

            try {
                // 1️⃣ Fetch ORDER_IS_READY orders using the filtered API
                const vendorRes = await axios.get(
                    `https://backend.maamaas.com/food/api/orders/vendor/order/status/${vendorId}?status=ORDER_IS_READY`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                let pendingOrders = vendorRes.data || [];

                // Handle paginated response if needed
                if (vendorRes.data && vendorRes.data.content) {
                    pendingOrders = vendorRes.data.content;

                    // Fetch all pages if paginated
                    if (vendorRes.data.totalPages > 1) {
                        let allPendingOrders = [...pendingOrders];

                        for (let page = 1; page < vendorRes.data.totalPages; page++) {
                            try {
                                const pageRes = await axios.get(
                                    `https://backend.maamaas.com/food/api/orders/vendor/order/status/${vendorId}?status=ORDER_IS_READY&page=${page}`,
                                    { headers: { Authorization: `Bearer ${token}` } }
                                );

                                if (pageRes.data && pageRes.data.content) {
                                    allPendingOrders = [...allPendingOrders, ...pageRes.data.content];
                                }
                            } catch (pageError) {
                                console.error(`Error fetching page ${page}:`, pageError.message);
                            }
                        }
                        pendingOrders = allPendingOrders;
                    }
                }

                // 2️⃣ Fetch TABLE_DINE_IN orders with ORDER_IS_READY items
                const confirmedRes = await axios.get(
                    `https://backend.maamaas.com/food/api/cart/get/ordertype=TABLE_DINE_IN/${vendorId}/ORDER_IS_READY`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                const confirmedOrdersDirect = confirmedRes.data || [];

                // 3️⃣ Combine both
                const allOrders = [...pendingOrders, ...confirmedOrdersDirect];

                // ✅ Sort orders by date (ascending - oldest first)
                allOrders.sort((a, b) => {
                    const dateA = new Date(a.orderDateAndTime || a.createdAt || 0);
                    const dateB = new Date(b.orderDateAndTime || b.createdAt || 0);
                    return dateA - dateB; // Ascending order
                });

                // ✅ Detect new orders for sound notification
                const prevOrderIds = prevOrdersRef.current.map((o) => o.id || o.orderId);
                const newOrders = allOrders.filter(
                    (o) => !prevOrderIds.includes(o.id || o.orderId)
                );

                if (newOrders.length > 0) {
                    notificationSound.play().catch((e) => console.warn("Autoplay prevented:", e));
                }

                setOrders(allOrders);
                prevOrdersRef.current = allOrders;

            } catch (error) {
                console.error("Error fetching orders:", error.response?.data || error.message);
            }
        };

        fetchOrders();

        // 🔁 Poll every 10 seconds
        const interval = setInterval(fetchOrders, 10000);
        return () => clearInterval(interval);

    }, [vendorId]);




    // Horizontal Auto-scroll
    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;

        let interval = setInterval(() => {
            if (!isHovered) {
                scrollContainer.scrollLeft += 1;
                if (scrollContainer.scrollLeft >= scrollContainer.scrollWidth / 2) {
                    scrollContainer.scrollLeft = 0;
                }
            }
        }, 20);

        return () => clearInterval(interval);
    }, [isHovered]);

    const getOrderColor = (orderType) => {
        const normalized = (orderType || "").trim().toLowerCase();
        switch (normalized) {
            case "dine_in":
                return "#1E90FF";
            case "takeaway":
                return "#FF6347";
            case "delivery":
                return "#20B2AA";
            case "table_dine_in":
                return "#2051b2ff";
            default:
                return "#ccc";
        }
    };



    const handleAcceptOrder = async (e, orderId) => {
        e.stopPropagation();
        const token = localStorage.getItem("authToken");
        if (!token) return;

        try {
            await axios.put(
                `https://backend.maamaas.com/food/orders/editstatus/${orderId}`,
                { orderStatus: "CONFIRMED" },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setOrders((prev) => prev.filter((order) => order.orderId !== orderId));
        } catch (error) {
            console.error("Accept error:", error.response?.data || error.message);
        }
    };

    const handleDeclineOrder = async (e, orderId) => {
        e.stopPropagation();

        const token = localStorage.getItem("authToken");
        if (!token) {
            alert("Authentication token is missing.");
            return;
        }

        try {
            const response = await axios.put(
                `https://backend.maamaas.com/food/api/orders/cancal/total/order/${orderId}`,
                {}, // ✅ Empty body (if your API doesn’t need one)
                {
                    headers: {
                        Authorization: `Bearer ${token}`, // ✅ Correct placement
                        "Content-Type": "application/json",
                    },
                }
            );


            // ✅ Update UI after successful cancellation
            setOrders((prev) => prev.filter((order) => order.orderId !== orderId));

        } catch (error) {
            console.error(
                "❌ Failed to update order status:",
                error.response?.data || error.message
            );

            if (error.response?.status === 403) {
                alert("Access denied. Your session may have expired — please log in again.");
            }
        }
    };


    return (
        <div>
            {/* Internal CSS */}
            <style>
                {`
                @media (min-width: 768px) {
                .order-card{
                display:none !important;
                }
               
                }

             
        @media (max-width: 768px) {
        
          .mobile-orders-wrapper {
            width: 100%;
            left: 0;
            right: 0;
        
            top: 0px;
            height: auto;
      
            padding: 10px;
            border-radius: 0;
          }

         /* Inside your <style> tag */
.mobile-scroll-container {
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  gap: 12px;
  padding-bottom: 10px;
  scroll-behavior: smooth;
  margin-top: 60px;
  background:#fff;
  -ms-overflow-style: none; /* IE */
  scrollbar-width: none; /* Firefox */
}

.order-card {
  flex-shrink: 0;
  width: 280px;          /* ✅ Fixed width for consistency */
  max-width: 90vw;       /* ✅ Prevents overflow on small screens */
    /* ✅ Keeps consistent height */
  border-radius: 10px;
  box-shadow: 0px 3px 6px rgba(0,0,0,0.15);
  padding: 12px;
  transition: all 0.3s ease-in-out;
}

        }

        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }

        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
        `}
            </style>

            <div
                className="mobile-orders-wrapper"
                style={{
                    position: "fixed",

                    right: "16px",
                    borderRadius: "8px",
                    padding: "10px",
                    marginTop: "40px",
                }}
            >
                <div
                    className="hide-scrollbar"
                    style={{
                        maxHeight: "600px",
                        overflowY: "auto",
                        paddingRight: "5px",
                        // marginTop: "30px",
                    }}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    <div className="mobile-scroll-container" ref={scrollContainerRef}>
                        {orders.map((order, index) => {
                            const uniqueId = order.orderId || order.cartId;
                            const itemsList = order.items || order.order || order.cartItems || [];

                            const isExpanded =
                                expandedOrder &&
                                (expandedOrder.orderId === uniqueId || expandedOrder.cartId === uniqueId);

                            return (
                                <div
                                    key={`${uniqueId}-${index}`}
                                    onClick={() => handleOrderClick(order)}
                                    className="order-card scroll-data-responsive"
                                    style={{
                                        cursor: "pointer",
                                        background: getOrderColor(order.orderType),
                                        position: "relative",
                                        height: isExpanded ? "auto" : "auto",
                                    }}
                                >

                                    <div style={{ width: "100%" }}>
                                        {/* Header */}
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                color: "#fff",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            <div style={{ display: "flex" }}>
                                                <div
                                                    style={{

                                                        color: "rgba(255, 255, 255, 0.9)",
                                                        marginRight: "10px",
                                                        fontSize: "18px",
                                                        transition: "transform 0.3s ease",
                                                        transform: expandedOrder?.orderId === order.orderId ? "rotate(180deg)" : "rotate(0deg)",
                                                        // Add this line:
                                                    }}
                                                >
                                                    ▼
                                                </div>

                                                Order ID: #{uniqueId}
                                            </div>
                                            <h5 style={{ marginTop: "0px" }}>{order.orderType === "DINE_IN" ? "DINEIN" : order.orderType || "N/A"}</h5>
                                        </div>




                                        {isExpanded && (
                                            <div style={{ marginTop: "-10px" }}>
                                                {/* Headers for items list */}
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    padding: '8px 10px',
                                                    borderRadius: '4px',
                                                    marginBottom: '0px',
                                                    fontWeight: 'bold',
                                                    fontSize: '16px',
                                                    color: '#fff'
                                                }}>
                                                    <div style={{ flex: 0, textAlign: 'left' }}>Items</div>
                                                    <div style={{ flex: 1, textAlign: 'center' }}>Quantity</div>
                                                </div>

                                                {order.orderType === "TABLE_DINE_IN" && (
                                                    <ul
                                                        style={{ listStyle: "none", padding: 0, marginLeft: "10px", fontWeight: "bold" }}
                                                        onClick={(e) => e.stopPropagation()}
                                                    >
                                                        {itemsList.map((item, idx) => (
                                                            <li
                                                                key={idx}
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                    alignItems: "center",
                                                                    color: "#000",
                                                                    fontSize: "14px",
                                                                    marginBottom: "3px",
                                                                    padding: "0px 10px 8px 10px",
                                                                    borderRadius: '4px'
                                                                }}
                                                            >
                                                                <div style={{ display: "flex", alignItems: "center", gap: "10px", flex: 2 }}>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={!!selectedItems[item.itemId]}
                                                                        onChange={(e) => {
                                                                            e.stopPropagation();
                                                                            handleCheckboxChangea(item.itemId);
                                                                        }}
                                                                    />
                                                                    <span style={{ fontWeight: "600" }}>
                                                                        {item.dishName || "Unnamed Dish"}
                                                                    </span>
                                                                </div>
                                                                <div style={{ flex: 1, textAlign: 'start' }}>
                                                                    × {item.updateQuantity ?? 0}
                                                                </div>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}

                                                {/* Non-TABLE_DINE_IN items */}
                                                <ul style={{ listStyle: "none", padding: 0, marginLeft: "10px", fontWeight: "bold" }}>
                                                    {itemsList
                                                        .filter((item) => item.status === "Okay")
                                                        .map((item, idx) => (
                                                            <li
                                                                key={idx}
                                                                style={{
                                                                    color: "#000",
                                                                    fontSize: "14px",
                                                                    marginBottom: "3px",
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                    alignItems: "center",
                                                                    padding: "0px 10px8px 10px",
                                                                    borderRadius: '4px'
                                                                }}
                                                                onClick={(e) => e.stopPropagation()}
                                                            >
                                                                <div style={{ display: "flex", alignItems: "center", gap: "8px", flex: 2 }}>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={!!checkedItems[item.listId]}
                                                                        onChange={() => handleCheckboxChange(item.listId)}
                                                                    />
                                                                    <span>{item.dishName}</span>
                                                                </div>
                                                                <div style={{ flex: 1, textAlign: 'start' }}>
                                                                    × {item.quantity}
                                                                </div>
                                                                <div style={{ flex: 1, textAlign: 'right' }}>
                                                                    <button
                                                                        onClick={() => handleCancelSingleOrder(item.listId)}
                                                                        style={{
                                                                            padding: "4px 8px",
                                                                            backgroundColor: "rgb(220, 53, 69)",
                                                                            color: "white",
                                                                            fontSize: "12px",
                                                                            fontWeight: "bold",
                                                                            border: "none",
                                                                            borderRadius: "5px",
                                                                            cursor: "pointer",
                                                                        }}
                                                                    >
                                                                        Cancel
                                                                    </button>
                                                                </div>
                                                            </li>
                                                        ))}
                                                </ul>
                                            </div>
                                        )}



                                        {order.orderType === "TABLE_DINE_IN" && (
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    marginTop: "10px",
                                                }}
                                            >
                                                <button
                                                    onClick={(e) => {


                                                        // Pass selected items to your API
                                                        handleAcceptOrderrsss(e, order.cartId);
                                                    }}
                                                    style={{
                                                        padding: "8px",
                                                        backgroundColor: "rgb(177 93 198)",
                                                        color: "white",
                                                        fontSize: "14px",
                                                        fontWeight: "bold",
                                                        border: "none",
                                                        borderRadius: "5px",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    Accept
                                                </button>
                                                <button
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleAcceptOrderrss(e, order.cartId); // ✅ using cartId instead of itemId
                                                    }}
                                                    style={{
                                                        padding: "8px",
                                                        backgroundColor: "rgb(177 93 198)",
                                                        color: "white",
                                                        fontSize: "14px",
                                                        fontWeight: "bold",
                                                        border: "none",
                                                        borderRadius: "5px",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    Decline
                                                </button>
                                            </div>
                                        )}




                                        {/* Buttons for non-TABLE_DINE_IN orders */}
                                        {order.orderType !== "TABLE_DINE_IN" && (
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    marginTop: "10px",
                                                }}
                                            >
                                                <button
                                                    onClick={(e) => handleAcceptOrderr(e, uniqueId)}
                                                    style={{
                                                        padding: "8px",
                                                        backgroundColor: "rgb(177 93 198)",
                                                        color: "white",
                                                        fontSize: "14px",
                                                        fontWeight: "bold",
                                                        border: "none",
                                                        borderRadius: "5px",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    Accept
                                                </button>
                                                <button
                                                    onClick={(e) => handleDeclineOrder(e, uniqueId)}
                                                    style={{
                                                        padding: "8px",
                                                        backgroundColor: "rgb(177 93 198)",
                                                        color: "white",
                                                        fontSize: "14px",
                                                        fontWeight: "bold",
                                                        border: "none",
                                                        borderRadius: "5px",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    Decline
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MobileDeliveryorders;

